export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080';

// Agent identity data is defined once in agentRegistry.ts.
// Re-export the maps so existing imports from '@/lib/constants' keep working.
export { AGENT_NAMES, AGENT_INTERNAL_NAMES } from './agentRegistry';

// Shared color mappings for TRFer risk/status badges
export const RISK_COLORS: Record<string, string> = {
  critical: 'bg-status-danger text-status-danger-fg border-status-danger-border',
  high: 'bg-status-warn-strong text-status-warn-strong-fg border-status-warn-strong-border',
  medium: 'bg-status-warn text-status-warn-fg border-status-warn-border',
  low: 'bg-status-ok text-status-ok-fg border-status-ok-border',
};
